<template>
    <div class="card-data" :class="xl?'xl':'lg'">
        <Tooltip
            v-show="tip"
            :tip="tip" />
        <div class="card-title">
            <h5>{{title}}</h5>
            <small v-if="sub">{{sub}}</small>
            <div style="height: 29px" v-else></div>
        </div>
        <div v-if="!loader">
            <Loader/>
        </div>
        <!-- <div v-else-if="!nodata">
            <EmptyStateChart/>
        </div> -->
        
        <div v-if="loader&&display&&nodata">
                <apexchart type="bar" height="250" :options="chartOptions" :series="data"></apexchart>
        </div>
        <div v-else-if="!display">
            <img src="@/assets/no-results.svg" alt="No permitido" class="invalid-display">
            <p class="invalid-display-text">Este gráfico está disponible sólo en escritorio</p>
        </div>
        
    </div>
</template>

<script>
import Loader from '@/components/Loader'
import Tooltip from '@/components/Tooltip'
import EmptyStateChart from '@/components/EmptyStateChart'
import _ from 'lodash' 

export default {
    name: 'BarLineGraphCard',
    components: {
        Tooltip,
        Loader,
        EmptyStateChart
    },
    props: {
        title: {
            type: String,
            required: true
        },
        sub: {
            type: String,
            required: false
        },
        tip: {
            type: String,
            default: ""
        },
        data: {
            type: Array,
            required: true
        },
        periodItems: {
            type: Array,
            required: true
        },
        sm: {
            type: Boolean,
            required: false
        },
        loader: {
            type: Boolean,
            required: true
        },
        xl: {
            type: Boolean,
            default: false
        },
        maxValue: {
            type: Number,
            required: true
        },
        maxPasserValue:{
            type: Number,
            required: true
        },
        maxVisitorValue:{
            type: Number,
            required: true
        },
        maxPercentage: {
            type: Number,
            required: true
        }
    },
    data: function(){
        return {
            tooltip: false
        }
    },
    computed: {
        display: function() {
            if(window.innerWidth < 768 && this.$store.getters["auth/getMaxRange"]){
                return false
            }
            return true
        },
        nodata: function(){
            let totaldata = 0
            _.each(this.data,(value,index)=>{
                _.each(value.data,(item)=>{
                    totaldata = totaldata + item 
                })
            }) 
            return totaldata
        },
        chartOptions: function() {
            return {    
                chart: {
                    type: 'bar',
                    stacked: true,
                    forceNiceScale: true,
                    toolbar: {
                        show: false
                    },
                    zoom: {
                        enabled: true
                    },
                    animations: {
                        enabled: false
                    }
                },
                dataLabels: {
                    enabled: false
                },
                stroke: {
                    width: [4, 1, 1],
                    curve: ['straight','straight','straight']
                },
                markers: {
                    size: [6, 0, 0],
                    strokeWidth: 0
                },
                colors: ["#a11461", "#720acb","#f1840a"],
                xaxis: {
                    type: 'categories',
                    categories: this.periodItems,
                    labels: {
                        rotate: -45,
                        rotateAlways: true,
                        hideOverlappingLabels: false,
                        maxHeight: 120,
                        formatter: function (value, timestamp) {
                            let monthNames = [
                                "Ene", "Feb", "Mar",
                                "Abr", "May", "Jun", "Jul",
                                "Ago", "Sep", "Oct",
                                "Nov", "Dic"
                            ]
                            if (value && value.includes('-')) {
                                return value.split('-')[0] + "-" + monthNames[value.split('-')[1] - 1]
                            } else if (value) {
                                if (value > 12) {
                                    return (value - 12).toString() + ":00 pm"
                                } else if (value == 12) {
                                    return  value + ":00 pm"
                                } else if (value == "00") {
                                    return "12:00 am"
                                }
                                return value + ":00 am"
                            }
                        }
                    },
                    tooltip: {
                        enabled: false
                    }
                },
                yaxis: [
                    {
                        // max: function(max){return max},
                        seriesName: 'Capture rate',
                        tickAmount:5,
                        opposite: true,
                        forceNiceScale: true,
                        axisBorder: {
                            show: false
                        },
                        labels: {
                            formatter: function (value) {
                                    return (value).toLocaleString('es')+"%"
                            },
                            style: {
                                colors: '#636363',
                            },
                        },
                        title: {
                            text: "Capture rate",
                            style: {
                                color: '#636363',
                            }
                        }
                    },
                    {
                        // max: function(max){return max},
                        seriesName: 'Transeúntes',
                        tickAmount: 5,
                        forceNiceScale: true,
                        axisBorder: {
                            show: true,
                            color: '#636363'
                        },
                        labels: {
                            formatter: function (value) {
                                return Math.round(value).toLocaleString('es')
                            },
                            style: {
                                colors: '#636363',
                            }
                        },
                        title: {
                            text: "Detectados",
                            style: {
                                color: '#636363',
                            }
                        },
                        tooltip: {
                            enabled: false
                        }
                    },
                    {
                        // max: function(max){return max},
                        seriesName: 'Transeúntes',
                        tickAmount: 5,
                        forceNiceScale: true,
                        axisBorder: {
                            show: false,
                            color: '#636363'
                        },
                        labels: {
                            formatter: function (value) {
                                if (Math.abs(value) > 999999) {
                                    return Math.sign(value)*((Math.abs(value)/100000).toFixed(1)) + 'MM'
                                } else { 
                                    return Math.trunc(value).toLocaleString('es')
                                }
                            },
                            show: false,
                            style: {
                                colors: '#636363',
                            }
                        },
                        title: {
                            show: false,
                            text: "",
                            style: {
                                color: '#636363',
                            }
                        },
                    }
                ],
                plotOptions: {
                    bar: {
                        horizontal: false,
                    },
                },
                fill: {
                    opacity: 1
                }
            }
        }
    }
}

</script>

<style lang="sass" scoped>
.invalid-display
    display: block
    max-width: 220px
    max-height: 220px
    margin: 12px auto 
.invalid-display-text
    width: 100%
    margin-bottom: 8px
    display: block
    font-family: Muli
    font-size: 16px
    text-align: center
    color: #302f2f
.fade-enter-active, .fade-leave-active 
    transition: all .3s

.fade-enter, .fade-leave-to  
    opacity: 0
    margin-right: -10px
</style>